(function(){
    'use strict'

    angular
    .module('app.servicios')
    .controller('servicios.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiServicios = 'api/Servicios'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            moneda:'0',
            unidadMedida: 0,
            tipoImpuesto: 0,
            codigoTarifa: 0
        };

        vm.title = 'Servicios';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        get();

        function get(){

            if(vm.id != 0){
                ApiBaseService.remoteController = apiServicios;
                var promise = ApiBaseService.getAll([companiaId, vm.id]);

                promise
                .then(function(data){
                    vm.data = data;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function doFormValidations()
        {
            validateSelectProperty('moneda');
            validateSelectProperty('tipoImpuesto');
            validateSelectProperty('codigoTarifa');
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiServicios;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiServicios;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/servicios');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                moneda:"0",
                unidadMedida: 0,
                tipoImpuesto: 0,
                codigoTarifa: 0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        vm.onSelectChanged = function(property){
            validateSelectProperty(property);
        };

    }
})();